(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["video/biliplus-redirect"] = factory();
	else
		root["video/biliplus-redirect"] = factory();
})(globalThis, () => {
return 